import { lazy } from 'react'

export const getH5Routes = () => {
  return [
    {
      path: '/h5/login',
      component: lazy(
        () => import(/* webpackChunkName: "H5Login" */ '../pages/background/reportManage/h5/login')
      ),
    },
    {
      path: '/h5/report/detail',
      component: lazy(
        () =>
          import(
            /* webpackChunkName: "H5ReportDetail" */ '../pages/background/reportManage/h5/reportDetail'
          )
      ),
    },
    {
      path: '/h5/report/preview',
      component: lazy(
        () =>
          import(
            /* webpackChunkName: "H5ReportDetail" */ '../pages/background/reportManage/h5/reportPreview'
          )
      ),
    },
    {
      path: '/h5/campusBusReservation/home',
      component: lazy(
        () =>
          import(/* webpackChunkName: "H5ReportDetail" */ '../pages/H5/campusBikeReservation/home')
      ),
    },
    {
      path: '/h5/campusBusReservation/userFeedback',
      component: lazy(
        () =>
          import(
            /* webpackChunkName: "H5ReportDetail" */ '../pages/H5/campusBikeReservation/userFeedback'
          )
      ),
    },
    {
      path: '/h5/campusBusReservation/userVehicleReservation',
      component: lazy(
        () =>
          import(
            /* webpackChunkName: "H5ReportDetail" */ '../pages/H5/campusBikeReservation/userVehicleReservation'
          )
      ),
    },
    { path: '*', component: () => require('../pages/notFound').default },
  ]
}
